// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deployments-container {
  padding: 20px 0;
  width: 100%;
  max-width: none;
  margin: 0;
}
.deployments-container h1 {
  color: #2C7EA0;
  margin-bottom: 1rem;
  font-weight: 600;
}
.deployments-container h5 {
  color: #495057;
  font-weight: 600;
}
.deployments-container .main-content-flex {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.deployments-container .sidebar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.deployments-container .sidebar.left {
  width: 220px;
  min-width: 220px;
  max-height: 80vh;
  overflow-y: auto;
}
.deployments-container .sidebar.left.closed {
  width: 50px;
  min-width: 50px;
  padding: 10px;
}
.deployments-container .sidebar .toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  padding: 4px 8px;
  font-size: 12px;
}
.deployments-container .sidebar h4 {
  color: #2C7EA0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-right: 2rem;
}
.deployments-container .center-content {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
}
.deployments-container .center-content h4 {
  color: #2C7EA0;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}
.deployments-container .card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}
.deployments-container .card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.25rem;
}
.deployments-container .card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
  font-size: 1.1rem;
}
.deployments-container .feature-checklist {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}
.deployments-container .deployment-table-wrapper {
  overflow-x: auto;
  width: 100%;
}
.deployments-container .deployment-matrix-table {
  min-width: max-content;
  width: 100%;
}
.deployments-container .deployment-matrix-table thead tr th {
  background-color: #e9ecef;
  color: #495057;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}
.deployments-container .deployment-matrix-table tbody tr td {
  vertical-align: middle;
}
.deployments-container .deployment-matrix-table .feature-installed {
  background-color: #d4edda !important;
  color: #155724;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}
.deployments-container .deployment-matrix-table .feature-not-installed {
  background-color: #cce5ff !important;
  color: #004085;
  text-align: center;
  white-space: nowrap;
}
.deployments-container .deployment-matrix-table .notes-cell {
  max-width: 250px;
  white-space: pre-wrap;
  word-break: break-word;
}
.deployments-container .table {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.deployments-container .table th {
  color: #495057;
  font-weight: 600;
  white-space: nowrap;
}
.deployments-container .table td {
  vertical-align: middle;
}
@media (max-width: 768px) {
  .deployments-container .main-content-flex {
    flex-direction: column;
  }
  .deployments-container .sidebar.left,
  .deployments-container .sidebar.left.closed {
    width: 100%;
    min-width: auto;
    max-height: none;
  }
}`, "",{"version":3,"sources":["webpack://./frontend/sass/pages/deployments.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AADJ;AAIE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAFJ;AAII;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFN;AAIM;EACE,WAAA;EACA,eAAA;EACA,aAAA;AAFR;AAMI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAJN;AAOI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AALN;AASE;EACE,OAAA;EACA,YAAA;EACA,gBAAA;AAPJ;AASI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAPN;AAWE;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qBAAA;AATJ;AAWI;EACE,yBAAA;EACA,gCAAA;EACA,qBAAA;AATN;AAWM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AATR;AAcE;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,WAAA;AAbJ;AAgBE;EACE,sBAAA;EACA,WAAA;AAdJ;AAgBI;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAdN;AAiBI;EACE,sBAAA;AAfN;AAkBI;EACE,oCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;AAlBN;AAsBE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AApBJ;AAsBI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AApBN;AAuBI;EACE,sBAAA;AArBN;AAyBE;EACE;IACE,sBAAA;EAvBJ;EA0BE;;IAEE,WAAA;IACA,eAAA;IACA,gBAAA;EAxBJ;AACF","sourcesContent":[".deployments-container {\n  padding: 20px 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  h1 {\n    color: #2C7EA0;\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n\n  h5 {\n    color: #495057;\n    font-weight: 600;\n  }\n\n  .main-content-flex {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .sidebar {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    transition: all 0.3s ease;\n    flex-shrink: 0;\n\n    &.left {\n      width: 220px;\n      min-width: 220px;\n      max-height: 80vh;\n      overflow-y: auto;\n\n      &.closed {\n        width: 50px;\n        min-width: 50px;\n        padding: 10px;\n      }\n    }\n\n    .toggle-btn {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      z-index: 10;\n      padding: 4px 8px;\n      font-size: 12px;\n    }\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-bottom: 1rem;\n      padding-right: 2rem;\n    }\n  }\n\n  .center-content {\n    flex: 1;\n    min-width: 0;\n    overflow-x: auto;\n\n    h4 {\n      color: #2C7EA0;\n      font-size: 1.2rem;\n      font-weight: 600;\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  .card {\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    margin-bottom: 1.5rem;\n\n    .card-header {\n      background-color: #f8f9fa;\n      border-bottom: 1px solid #dee2e6;\n      padding: 1rem 1.25rem;\n\n      h5 {\n        margin: 0;\n        color: #495057;\n        font-weight: 600;\n        font-size: 1.1rem;\n      }\n    }\n  }\n\n  .feature-checklist {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem 1.5rem;\n    padding: 0.75rem 1rem;\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n  }\n\n  .deployment-table-wrapper {\n    overflow-x: auto;\n    width: 100%;\n  }\n\n  .deployment-matrix-table {\n    min-width: max-content;\n    width: 100%;\n\n    thead tr th {\n      background-color: #e9ecef;\n      color: #495057;\n      font-weight: 600;\n      white-space: nowrap;\n      vertical-align: middle;\n    }\n\n    tbody tr td {\n      vertical-align: middle;\n    }\n\n    .feature-installed {\n      background-color: #d4edda !important;\n      color: #155724;\n      font-weight: 600;\n      text-align: center;\n      white-space: nowrap;\n    }\n\n    .feature-not-installed {\n      background-color: #cce5ff !important;\n      color: #004085;\n      text-align: center;\n      white-space: nowrap;\n    }\n\n    .notes-cell {\n      max-width: 250px;\n      white-space: pre-wrap;\n      word-break: break-word;\n    }\n  }\n\n  .table {\n    background-color: #fff;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    th {\n      color: #495057;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n\n    td {\n      vertical-align: middle;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .main-content-flex {\n      flex-direction: column;\n    }\n\n    .sidebar.left,\n    .sidebar.left.closed {\n      width: 100%;\n      min-width: auto;\n      max-height: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
